module.exports = __webpack_public_path__ + "img/reading.6b6035e2.png";